import type { NotificationPreferences } from '@gwc/shared';
import { api } from '../lib/api';

export const notificationsApi = {
  getPreferences: () =>
    api.get<{ preferences: NotificationPreferences }>('/auth/me/notifications').then((r) => r.preferences),
  updatePreferences: (patch: Partial<NotificationPreferences>) =>
    api
      .patch<{ preferences: NotificationPreferences }>('/auth/me/notifications', patch)
      .then((r) => r.preferences),
  sendAnnouncement: (title: string, body: string) =>
    api.post<{ ok: true; sent: number }>('/notifications/announcement', { title, body }),
};
